import styled from "@emotion/styled";
import { TABLET_QUERY_MIN_WIDTH } from "/constants/vp-sizes";
export const StyledTemplateHomePageContent = styled.div`
  .mobile-navigation-wrapper {
    display: none;
  }

  .featured-categories-wrapper {
    margin-top: 52px;
  }

  .most-popular-wrapper {
    margin-top: 52px;
  }

  .new-and-notable-wrapper {
    margin-bottom: 100px;
  }

  @media (max-width: ${TABLET_QUERY_MIN_WIDTH}) {
    .mobile-navigation-wrapper {
      display: flex;
      width: 100%;
      margin-top: 24px;
    }

    .featured-categories-wrapper {
      margin-top: 32px;
    }

    .most-popular-wrapper {
      margin-top: 72px;
    }
  }
`;
